import React from 'react';
import Chart from 'react-apexcharts';

interface GraficoAreaProps {
  height?: number;
  series: {
    name: string;
    data: number[];
  }[];
  options?: {
    title?: {
      text?: string;
    };
    colors?: string[];
    dataLabels?: {
      enabled?: boolean;
    };
    theme?: {
      mode?: 'dark' | 'light' | undefined;
    };
    xaxis?: { 
      categories?: string[];
    };
    yaxis?: {
      labels?: {
        formatter?: (value: number) => string;
      };
    };
  };
}

const GraficoColuna: React.FC<GraficoAreaProps> = ({ series, options = {}, height }) => {
  return (
    <React.Fragment>
      <Chart
        type='bar'
        height={height || 250}
        series={series}
        options={{
          chart: {
            toolbar: {
              show: false 
            }
          },
          legend: {  // Alterado para opcional
            position: 'top',
            show: false,
          },
          title: { text: options.title?.text },
          colors: options.colors,
          dataLabels: { enabled: options.dataLabels?.enabled },
          theme: { mode: options.theme?.mode },
          xaxis: { categories: options.xaxis?.categories },
          yaxis: {
            labels: {
              formatter: (value) => 
                new Intl.NumberFormat('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }).format(value),
                show: false 
            }
          },
          plotOptions: {
            bar: { horizontal: false }
          },
        }}
      />
    </React.Fragment>
  );
};

export default GraficoColuna;

